export interface ReviewVerificationTaskDto {
  isApproved: boolean;
  reason?: string;
}
